import axios from "axios";
import { requestBuilder } from "../../misc/util";

const state = {
  loggedIn: false,
};

const getters = {
  isLoggedIn: (rootState) => rootState.loggedIn
};

const mutations = {
  SET_LOGIN_STATE(rootState, payload) {
    rootState.loggedIn = payload;
  }
};

const actions = {
  changeLoginState({ commit }, payload) {
    commit("SET_LOGIN_STATE", payload);
  },
  async checkAuthStatus({ commit }) {
    const url = "/users/auth-status";
    const method = "GET";
    const requestOptions = requestBuilder(url, method);

    try {
      const response = await axios.request(requestOptions);
      this.dispatch("changeLoginState", true);
    } catch (error) {
      this.dispatch("changeLoginState", false);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
